import React from 'react';

/**
 * Simple notice shown after JWT session expires (before login).
 */
const SessionExpiredNoticeModal = ({ onConfirm }) => {
  return (
    <div className="p-6 pt-10 text-center">
      <div className="w-16 h-16 bg-amber-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg
          className="w-8 h-8 text-amber-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>

      <h2 className="text-2xl font-bold text-gray-900 mb-2">Session Expired</h2>
      <p className="text-gray-600 text-sm mb-6 leading-relaxed">
        Your session has expired. Your progress has been saved.
        <br />
        Please sign in again to continue.
      </p>

      <button
        type="button"
        onClick={onConfirm}
        className="w-full bg-jet-yellow text-gray-900 border-0 py-3 px-6 rounded-md text-sm font-semibold cursor-pointer transition-all duration-300 hover:bg-jet-yellow-hover focus:outline-none focus:shadow-[0_0_0_2px_rgba(255,215,0,0.4)]"
      >
        OK
      </button>
    </div>
  );
};

export default SessionExpiredNoticeModal;
